export default __webpack_public_path__ + "media/icons/video-playlist-47631303.svg";